import { media } from '@/styles/Qtheme';
import { styled } from 'styled-components';

export const Container = styled.div<{ isDarkmode: boolean }>`
  padding: 48px 36px;
  background-color: ${({ theme }) => theme.COLORS.tableBg};
  border-radius: 8px;

  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const CheckInHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const CheckInHeaderTitle = styled.div`
  font-size: 22px;
  font-weight: 600;
  color: ${({ theme }) => theme.COLORS.textw};

  @media ${media.mobile} {
    font-size: 16px;
  }
`;

export const CheckInHeaderSubTitle = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.COLORS.sectionDesc};
  line-height: 1.4;

  @media ${media.mobile} {
    font-size: 14px;
    line-height: 1.3;
  }
`;

export const CheckInBody = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  row-gap: 20px;
  column-gap: 17px;

  @media ${media.tablet} {
    grid-template-columns: repeat(3, 1fr);
  }

  @media ${media.mobile} {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 17px;
    column-gap: 8px;
  }
`;

export const CheckInBodyItem = styled.div<{
  isDarkmode: boolean;
  status: string;
}>`
  border: ${({ isDarkmode, status }) => {
    if (isDarkmode) {
      return status === 'active' || status === 'claimed'
        ? '1px solid #00FF9C'
        : '1px solid #333333';
    } else {
      return status === 'active' || status === 'claimed'
        ? '1px solid #00B56F'
        : '1px solid #BDBDBD';
    }
  }};

  background-color: ${({ isDarkmode, status }) => {
    if (isDarkmode) {
      return status === 'active' || status === 'claimed'
        ? 'rgba(31, 55, 45, 0.4)'
        : '#1F1F1F';
    } else {
      return status === 'active' || status === 'claimed'
        ? '#DEE2E1'
        : '#F6E8E5';
    }
  }};

  border-radius: 8px;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const CheckInRewardButton = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  background-color: #ff5c17;

  padding: 8px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    scale: 1.2;
  }
`;

export const CheckInBodyItemReward = styled.div`
  padding: 34px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const RewardTitle = styled.div`
  font-size: 26px;
  font-weight: 800;
  z-index: 1;

  @media ${media.mobile} {
    font-size: 24px;
  }
`;

export const RewardCurrency = styled.div`
  font-size: 14px;
  font-weight: 800;
  z-index: 1;

  @media ${media.mobile} {
    font-size: 12px;
    position: relative;
    left: 1px;
  }
`;

export const RewardImg = styled.div`
  width: 100px;
  height: 100px;
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;

  @media ${media.mobile} {
    width: 88px;
    height: 88px;
  }
`;

export const FirstLayer = styled.svg`
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
`;

export const SecondLayer = styled.svg`
  position: absolute;
  top: 9.5%;
  left: 9.88%;
`;

export const ThirdLayer = styled.svg`
  position: absolute;
  left: 15.84%;
  top: 15.44%;
`;

export const CheckInBodyItemDay = styled.div<{
  isDarkmode: boolean;
  status: string;
}>`
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 22px;
  font-weight: 600;
  color: ${({ status, theme }) =>
    status === 'active' || status === 'claimed'
      ? theme.COLORS.greenText
      : theme.COLORS.textw};

  border-top: ${({ isDarkmode, status }) => {
    if (isDarkmode) {
      return status === 'active' || status === 'claimed'
        ? '1px solid #00FF9C'
        : '1px solid #333333';
    } else {
      return status === 'active' || status === 'claimed'
        ? '1px solid #00B56F'
        : '1px solid #BDBDBD';
    }
  }};

  @media ${media.mobile} {
    font-size: 18px;
    height: 45px;
  }
`;

export const TradeButton = styled.button`
  align-self: center;
  width: 100%;
  max-width: 320px;
  height: 54px;
  border-radius: 4px;
  border: 1px solid #ff5c17;
  color: #ff5c17;
  font-size: 16px;
  font-weight: 500;
  font-family: 'Pretendard', sans-serif;

  @media ${media.mobile} {
    max-width: 100%;
    font-size: 14px;
    height: 42px;
  }
`;

export const TimezoneInfoContainer = styled.div<{ isDarkmode: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 48px;
  padding: 20px 24px;
  background-color: ${({ isDarkmode }) =>
    isDarkmode ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.02)'};
  border-radius: 8px;

  @media ${media.mobile} {
    margin-top: 32px;
    padding: 16px 20px;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
`;

export const TimezoneInfoIcon = styled.span`
  font-size: 20px;
  line-height: 1.4;
  opacity: 0.6;
  flex-shrink: 0;

  @media ${media.mobile} {
    font-size: 18px;
  }
`;

export const TimezoneInfoContent = styled.div`
  font-size: 13px;
  font-weight: 400;
  color: ${({ theme }) => theme.COLORS.sectionDesc};
  line-height: 1.8;
  text-align: left;
  white-space: pre-line;
  opacity: 0.8;
  flex: 1;

  @media ${media.mobile} {
    font-size: 12px;
    line-height: 1.6;
    text-align: center;
  }
`;
